import { encode } from '@msgpack/msgpack';
import type { UPLOAD_TYPE } from 'src/types/enum';

export function buildFilesManifest(files: File[]) {
  return files.map((f) => ({
    relative_path: (f as any).webkitRelativePath || f.name,
    name: f.name,
    original_size: f.size,
    file_modified_on: new Date(f.lastModified).toISOString(),
    format: f.name.split('.').pop() || null
  }));
}

export async function compressManifest(files: File[]): Promise<File> {
  const msgpackBytes = encode(buildFilesManifest(files));
  const compressedBlob = await new Response(
    new Blob([msgpackBytes]).stream().pipeThrough(new CompressionStream('gzip'))
  ).blob();
  return new File([compressedBlob], 'files_manifest', {
    type: 'application/gzip'
  });
}

export function buildSessionPayload(
  parentFolderId: string | number,
  acceptedFiles: File[],
  transactionId: string,
  currentUploadType?: UPLOAD_TYPE,
  overwrite?: boolean
): Record<string, any> {
  const ua = navigator.userAgent;
  const browserMatch = /(Chrome|Firefox|Safari|Edge|OPR)\/(\S+)/.exec(ua);
  const osMatch = /\(([^)]*)\)/.exec(ua);

  const payload: Record<string, any> = {
    parent_id: Number(parentFolderId),
    upload_type: currentUploadType ?? 'file',
    tier: 'medium',
    is_permanent: false,
    overwrite: overwrite ?? false,
    user_agent: ua,
    browser: browserMatch?.[1] ?? 'Unknown',
    os: osMatch?.[1]?.split(';')[0]?.trim() ?? navigator.platform
  };

  const sourcePath = (acceptedFiles[0] as any)?.webkitRelativePath?.split('/')[0];
  if (sourcePath) {
    payload.source_parent_path = sourcePath;
  }
  if (browserMatch?.[2]) {
    payload.browser_version = browserMatch[2];
  }
  if ((navigator as any).userAgentData) {
    payload.client_hints = JSON.stringify((navigator as any).userAgentData);
  }

  return payload;
}
